interface Props {
  onClose: () => void;
}

export function ShortcutsHelp({ onClose }: Props) {
  return (
    <div
      className="fixed inset-0 z-40 bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-zinc-900 rounded-lg shadow-xl p-6 max-w-md w-full border border-zinc-200 dark:border-zinc-800"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold mb-3">Keyboard shortcuts</h2>
        <table className="w-full text-sm">
          <tbody>
            <Row keys="/" text="focus the query box" />
            <Row keys="j  /  k" text="next / previous result" />
            <Row keys="Enter" text="toggle context for focused result" />
            <Row keys="e" text="explain (semantic search for similar chunks)" />
            <Row keys="?" text="show this help" />
            <Row keys="Esc" text="close modals" />
          </tbody>
        </table>
        <button
          onClick={onClose}
          className="mt-4 w-full rounded bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium px-3 py-2"
        >
          Close
        </button>
      </div>
    </div>
  );
}

function Row({ keys, text }: { keys: string; text: string }) {
  return (
    <tr className="border-b border-zinc-100 dark:border-zinc-800 last:border-0">
      <td className="py-2 pr-3 font-mono text-xs whitespace-nowrap">{keys}</td>
      <td className="py-2 text-zinc-700 dark:text-zinc-300">{text}</td>
    </tr>
  );
}
